import React, { PureComponent } from 'react';
import { Area, AreaChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from 'recharts';
import './AreaChartGraph.scss'



export default class AreaChartGraph extends PureComponent {
  static jsfiddleUrl = 'https://jsfiddle.net/alidingling/xqjtetw0/';

  constructor(props, context) {
    super(props, context);
    this.state = {
      activeStatusCards: props.activeStatusCards === undefined ? null : props.activeStatusCards,
      areaLineConfig: [
        // { dataKey: "OneTime", stroke: "#e3c848", strokeWidth: 2, fill: "#fcfaec", isActive: true },
        { dataKey: "Daily", stroke: "#e3c848", strokeWidth: 2, fill: "#fcfaec", isActive: true },
        { dataKey: "Weekly", stroke: "#5ac796", strokeWidth: 2, fill: "#eef9f4", isActive: true },
        { dataKey: "BiWeekly", stroke: "#b57dff", strokeWidth: 2, fill: "#eef9f4", isActive: true },
        { dataKey: "Monthly", stroke: "#ff6d91", strokeWidth: 2, fill: "#f8f2ff", isActive: true }
      ],
      lineChartList: props.lineChartList ? props.lineChartList : [],
    };
  }



  componentWillReceiveProps = props => {
    let { areaLineConfig } = this.state
    let { lineChartList, activeStatusCards } = props
  
    if (activeStatusCards.length === 0) {
      areaLineConfig = areaLineConfig.map(obj => ({ ...obj, isActive: true }));
    } else {
      areaLineConfig = areaLineConfig.map(obj => ({ ...obj, isActive: false }));
      areaLineConfig
        .filter(obj => activeStatusCards.indexOf(obj.dataKey?.toLowerCase()) !== -1)
        .forEach(obj => { obj.isActive = true; });
    }

    this.setState({ areaLineConfig, lineChartList });
  };

  // ✅ Custom tooltip to handle arrays/objects properly
  CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {

      return (
        <div className="custom-tooltip" style={{ background: "#fff", padding: "10px", border: "1px solid #ccc" }}>
          <p><strong>{label}</strong></p>

          {payload.map((item, index) => {
            let displayValue = item.value;

            // 👉 If value is an array, sum collectionAmount
            if (Array.isArray(displayValue)) {
              displayValue = displayValue.reduce(
                (sum, obj) => sum + (parseFloat(obj.collectionAmount) || 0),
                0
              );
            }

            // 👉 If value is an object, extract a key (example: collectionAmount)
            if (typeof displayValue === "object" && displayValue !== null) {
              displayValue = displayValue.collectionAmount || 0;
            }

            return (
              <p key={index} style={{ color: item.stroke }}>
                {item.name}: {displayValue}
              </p>
            );
          })}
        </div>
      );
    }
    return null;
  };

  render() {
    let { areaLineConfig, lineChartList } = this.state
    return (
      <div style={{height:"90%"}}>
      <AreaChart
        className="areaChart" 
        width={700}
        height={300}
        data={lineChartList}
        margin={{
          top: 20, right: 20, bottom: 20, left: 20,
        }}
        fontSize={13}
      >
        <Legend iconType={'circle'} align={'right'} iconSize={8}
          wrapperStyle={{
            top: "-37px"
          }}
        />

        <CartesianGrid vertical={false} />

        <XAxis dataKey="name" tick={true} />

        <YAxis axisLine={false} />

        {/* Area lines iteration */}
        {areaLineConfig.filter(obj => obj.isActive).map((config, index) => (
          <Area
            key={index}
            dataKey={config.dataKey}
            stroke={config.stroke}
            activeDot={true}
            strokeWidth={config.strokeWidth}
            fill={config.fill}
          />

        ))}


        <Tooltip content={<this.CustomTooltip />} />


      </AreaChart>
      </div>
    );
  }
}

